import { ChakraProvider } from "@chakra-ui/react";
import theme from "./app/theme";
import MainPage from "./app/pages/main";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import Fonts from "./app/theme/Fonts";

export const App = () => {
  return (
    <ChakraProvider theme={theme}>
      <Fonts />

      <BrowserRouter>
        <Switch>
          <Route path="/:surveyId" strict={true} render={() => <MainPage />} />
          <Redirect from="*" to="/" />
        </Switch>
      </BrowserRouter>
    </ChakraProvider>
  );
};
